import styled from "styled-components";
import {
  Modal as BaseModal,
  Button
} from "@company-mrv/mrv-design-system/components";

export const Modal = styled(BaseModal)`
  .modal-content {
    width: 100%;
    max-width: 554px;
    border-radius: 16px;
    padding: 0;

    @media (max-width: 768px) {
      max-width: 100%;
      max-height: 90vh;
      border-radius: 16px 16px 0 0;
      position: fixed;
      bottom: 0;
      margin: 0;
    }
  }

  .modal-header {
    margin: 0;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 40px;
  padding: 40px;
  overflow-y: auto;
  max-height: 90vh;
`;

export const CloseButton = styled.div`
  display: none;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;
  padding: 20px 20px 8px;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ isSensia }) => (isSensia ? "flex-start" : "center")};
  align-self: stretch;
  padding: 16px 0;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 16px;
  text-align: left;
`;

export const Title = styled.h2`
  font-weight: 700;
  font-size: 18px;
  line-height: 1.33;
  color: #242625;
  margin: 0;
`;

export const Description = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  color: #242625;
  margin: 0;
  white-space: pre-line;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-self: stretch;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;

    button {
      width: 100%;
    }
  }
`;

export const ButtonEntendi = styled(Button)`
  min-width: 136px;
`;

export const CloseIconButton = styled(Button)`
  min-width: auto;
  padding: 0;
`;
